import styled from 'styled-components/macro';
import { blue2, disabledBlue } from '../common/colorConstants';

export const Container = styled.div`
  background-color: #fff;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 0;
  overflow-y: scroll;
  // @media (max-height: 742px) {
  //   padding-top: 90px;
  //   @media (max-width: 450px) {
  //     padding-top: 0px;
  //   }
  // }
`;

export const Holder = styled.div`
  font-family: 'Lato';
  align-self: center;
  margin: 120px auto 120px;
  background-color: white;
  border-radius: 10px;
  width: 440px;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.38);
  @media (max-width: 450px) {
    width: 100%;
    margin: 50px 0px 0px 0px;
    border-radius: 0px;
  }
`;

export const HaveAccountContainer = styled.div`
  margin-top: 40px;
  color: #22386f;
  text-align: center;
  font-size: 11px;
`;

export const Logo = styled.img`
  width: 25px;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0px;
  padding: 70px 90px 30px 90px;
  @media (max-width: 300px) {
    padding: 70px 30px 30px 30px;
  }
`;

export const FormItem = styled.div`
  width: 100%;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
`;

export const Title = styled.div`
  color: #22386f;
  font-size: 30px;
  font-weight: 400;
  margin-bottom: 25px;
  @media (max-width: 400px) {
    font-size: 20px;
    text-align: center;
  }
`;
export const ServerError = styled.div`
  color: red;
  margin: 0px 0px 50px 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 300;
`;

export const RegistrationButton = styled.button`
  width: 100%;
  padding: 28px;
  font-size: 18px;
  margin-bottom: 0px;
  background-color: ${blue2};
  color: white;
  border: none;
  border-radius: 0px 0px 10px 10px;
  transition: 0.3s;
  outline: none;
  cursor: pointer;

  &:disabled {
    background-color: ${disabledBlue};
    cursor: not-allowed;
    opacity: 0.6;
  }

  @media (max-width: 450px) {
    border-radius: 0px;
  }
`;

export const ServerErrorMessage = styled.div`
  display: ${(props) => (props.hide ? 'none' : 'initial')};
`;

export const InfoIcon = styled.img`
  margin: 0;
  width: 14px;
  height: 14px;
  z-index: 100;
  cursor: pointer;
  position: absolute;
  left: 234px;
  top: 30px;
  @media (max-width: 400px) {
    display: none;
  }
`;

/** * Global Feature Styles ***/

export const Error = styled.div`
  color: red;
  margin-top: 3px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: 300;
`;
